import React from "react";

const DBadge = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="17"
      viewBox="0 0 22 17"
      fill="none"
    >
      <rect y="0.75" width="22" height="16" rx="8" fill="#FFBBBB" />
      <path
        d="M11.1392 8.47607C11.1392 9.19971 11 9.80469 10.7217 10.291C10.4463 10.7744 10.0464 11.1392 9.52197 11.3853C8.99756 11.6284 8.36621 11.75 7.62793 11.75H5.80859V5.3252H7.82568C8.49951 5.3252 9.08398 5.44531 9.5791 5.68555C10.0742 5.92285 10.458 6.27588 10.7305 6.74463C11.0029 7.21045 11.1392 7.7876 11.1392 8.47607ZM9.72412 8.51123C9.72412 8.03662 9.65381 7.64697 9.51318 7.34229C9.37549 7.03467 9.17041 6.80762 8.89795 6.66113C8.62842 6.51465 8.29443 6.44141 7.896 6.44141H7.1709V10.625H7.75537C8.42041 10.625 8.91406 10.4478 9.23633 10.0933C9.56152 9.73877 9.72412 9.21143 9.72412 8.51123ZM14.9492 11.75H13.5869V6.45898H11.8423V5.3252H16.6938V6.45898H14.9492V11.75Z"
        fill="#860101"
      />
    </svg>
  );
};

export default DBadge;
